// extracted by mini-css-extract-plugin
module.exports = {"settings":"Settings_settings__1nxX7","settingsInner":"Settings_settingsInner__Ik0RI"};